import { CONTRACTS_ROUTER_PATHS, CONTRACTS_ROUTER_NAMES } from "./names";

export default [
  {
    path: CONTRACTS_ROUTER_PATHS.ITEMS,
    name: CONTRACTS_ROUTER_NAMES.ITEMS,
    meta: {
      title: "Контракты",
      authRequired: true,
    },
    component: () => import("@/modules/contracts/views/items.vue"),
  },
  {
    path: CONTRACTS_ROUTER_PATHS.EDIT,
    name: CONTRACTS_ROUTER_NAMES.EDIT,
    meta: {
      title: "Редактирование контракта",
      authRequired: true,
    },
    component: () => import("@/modules/contracts/views/edit.vue"),
  },
  {
    path: CONTRACTS_ROUTER_PATHS.CREATE,
    name: CONTRACTS_ROUTER_NAMES.CREATE,
    meta: {
      title: "Создание контракта",
      authRequired: true,
    },
    component: () => import("@/modules/contracts/views/edit.vue"),
  },
  {
    path: CONTRACTS_ROUTER_PATHS.CREATE_AGREEMENT,
    name: CONTRACTS_ROUTER_NAMES.CREATE_AGREEMENT,
    meta: {
      title: "Создание соглашения",
      authRequired: true,
    },
    component: () => import("@/modules/contracts/views/edit.vue"),
  },
];
